import React from 'react';
import { getItemOfSessionStorage, setItemInSessionStorage } from "../services/common/utils";
import {SELECTED_LANG, AUTH_KEY} from "../services/common/Constants"
export {
    GTMScreenView, 
    GTM_View_Item, 
    GTM_Login, 
    GTM_SignUp, 
    GTM_OtpValidation, 
    GTM_Pay, 
    GTM_Change_Msisdn, 
    GTM_Logout, 
    GTM_View_Items_List, 
    GTM_Select_Item, 
    GTM_ChangeLanguage, 
    GTM_BalanceTransfer,
    GTM_Internet_Transfer,
    GTM_NojoomRedeem, 
    GTM_NojoomTransfer,
    GTM_NojoomBuy,
    GTM_NojoomManage, 
    GTM_Set_primary,
    GTM_Begin_Checkout,
    GTM_Add_Payment_Info,
    GTM_Purchase
};

const previousPage = (pagename) =>{
    if(pagename == sessionStorage.getItem("prevPage")){
        if(sessionStorage.getItem("subPrev") != "null" && sessionStorage.getItem("subPrev") != null) 
            return sessionStorage.getItem("subPrev")
        else return ""
    }else{ 
        if(sessionStorage.getItem("prevPage") != "null" && sessionStorage.getItem("prevPage") != null)
            return sessionStorage.getItem("prevPage") 
        else return  ""
    }
}
const GTMScreenView = (pagename,msisdn, logintype) =>{
    window.dataLayer.push({
        event: 'e_screenview',
        p_language: getItemOfSessionStorage(SELECTED_LANG),
        p_subsite: "CORPWEB",
        p_channel: "WEB",
        p_previouspagename: previousPage(pagename),
        p_customerid: getItemOfSessionStorage("Customerid") ?? "", //email or id 
        p_customertype: getItemOfSessionStorage(AUTH_KEY) ? "existing" : "guest", // auth key from session storage
        p_planid: JSON.parse(getItemOfSessionStorage("c_net"))?.planid ?? '',
        p_planname: JSON.parse(getItemOfSessionStorage("c_net"))?.planname ?? "",
        p_logintype: getItemOfSessionStorage(AUTH_KEY) ? logintype : "Guest",
        p_loginstatus: getItemOfSessionStorage(AUTH_KEY) ? "yes" : "no",
        p_msisdn: msisdn,
        p_pagename: pagename,
        p_status: 'Success',  
        p_statusdesc: 'Page loaded SuccessFully', 
    }); 
    setItemInSessionStorage("currentPage", JSON.stringify({pagename:pagename, msisdn: msisdn}));
    if(pagename !== sessionStorage.getItem("prevPage")){
        sessionStorage.setItem("subPrev", sessionStorage.getItem("prevPage"));
        sessionStorage.setItem("prevPage", pagename)}
    } 

const GTM_OtpValidation = (pagename,msisdn, logintype, message) =>{
    window.dataLayer.push({
        event: 'e_otpvalidation',
        p_language: getItemOfSessionStorage(SELECTED_LANG),
        p_subsite: "CORPWEB",
        p_channel: "WEB",
        p_previouspagename: previousPage(pagename),
        p_customerid: getItemOfSessionStorage("Customerid") ?? "",
        p_customertype: getItemOfSessionStorage(AUTH_KEY) ? "existing" : "guest",        
        p_planid: JSON.parse(getItemOfSessionStorage("c_net"))?.planid ?? '',
        p_planname: JSON.parse(getItemOfSessionStorage("c_net"))?.planname ?? "", 
        p_logintype: getItemOfSessionStorage(AUTH_KEY) ? logintype : "Guest",        
        p_loginstatus: getItemOfSessionStorage(AUTH_KEY) ? "yes" : "no",        
        p_msisdn: msisdn,        
        p_pagename: pagename,       
        p_status: getItemOfSessionStorage(AUTH_KEY) ? "Success" : "Failure",        
        p_statusdesc: message
     })
}

const GTM_SignUp =(pagename, msisdn, logintype, socialMedia ) =>{
    window.dataLayer.push({
        event: 'e_signup',
        p_language:getItemOfSessionStorage(SELECTED_LANG),
        p_subsite: "CORPWEB",
        p_channel: "WEB",
        p_previouspagename: previousPage(pagename),
        p_customerid: getItemOfSessionStorage("Customerid") ?? "",
        p_customertype: getItemOfSessionStorage(AUTH_KEY) ? "existing" : "guest",        
        p_planid: JSON.parse(getItemOfSessionStorage("c_net"))?.planid ?? '',
        p_planname: JSON.parse(getItemOfSessionStorage("c_net"))?.planname ?? "",        
        p_logintype: getItemOfSessionStorage(AUTH_KEY) ? logintype : "Guest",        
        p_loginstatus: getItemOfSessionStorage(AUTH_KEY) ? "yes" : "no",        
        p_msisdn: msisdn,        
        p_pagename: pagename,        
        p_status: getItemOfSessionStorage(AUTH_KEY) ? "Success" : "Failure",        
        p_statusdesc: getItemOfSessionStorage("loginStatus"),    
        p_socialplatformname: socialMedia
    });
}

const GTM_Login = (pagename, msisdn, logintype, socialMedia) =>{
    window.dataLayer.push({
        event: 'e_login',
        p_language: getItemOfSessionStorage(SELECTED_LANG),
        p_subsite:"CORPWEB",
        p_channel: "WEB",
        p_previouspagename: previousPage(pagename),
        p_customerid: getItemOfSessionStorage("Customerid") ?? "",
        p_customertype: getItemOfSessionStorage(AUTH_KEY) ? "existing" : "guest",   //      
        p_planid: JSON.parse(getItemOfSessionStorage("c_net"))?.planid ?? '',
        p_planname: JSON.parse(getItemOfSessionStorage("c_net"))?.planname ?? "",         
        p_logintype: getItemOfSessionStorage(AUTH_KEY) ? logintype : "Guest",        
        p_loginstatus: getItemOfSessionStorage(AUTH_KEY) ? "yes" : "no",        
        p_msisdn: msisdn,        
        p_pagename: pagename,        
        p_status: getItemOfSessionStorage(AUTH_KEY) ? "Success" : "Failure",        
        p_statusdesc: getItemOfSessionStorage("loginStatus"),  
        p_socialplatformname: socialMedia ?? ""
    });
}

const getId = (list, type) => {
    if(type === "NojoomEarnPoints" || type === "nojoomPartners" || type === "nojoomPartner" || type === "transferPoints" || type === "OoredeoRewards" || type === "ooredoRewardsList" || type === "NojoomPartner" || type === "GTL" || type === "TransferPoints" || type === "OoredeoRewardsDetails" || type === "Nojoom_Partner" || type === "OoredeooServices") return list?.id;
    else if(type === "NojoomPay") return list?.memberid;
    else return list?.offerid
}
const getItemName = (list, type) =>{
    if(type === "SpecialDeals_Postpaid" || type === "DigitalServices" || type=== "NojoomEarnPoints" || type === "nojoomPartners" || type === "nojoomPartner" || type === "transferPoints" || type === "OoredeoRewards" || type === "NojoomPartner" || type === "OoredeoRewardsDetails" || type === "Nojoom_Partner" || type === "DigitalService") return list?.name;
    else if(type === "addons" || type === "SpecialDeals_Prepaid" || type === "bundles" || type === "roamingDeals" || type === "ooredoRewardsList" || type === "RoamingMultiContries" || type === "RoamingCountries" || type === "GTL" || type === "addonDetails" || type=== "SpecialDealsPrePaid" || type === "recentpurchase" || type === "addon" || type === "OoredeooServices" || type === "roaming" ) return list?.title;
    else if(type === "NojoomHotDeals") return "Nojoom Hot Deals"
    else if(type === "TransferPoints") return list?.displaytext ;
}
const getPrice = (list, type) =>{
    if(type === "SpecialDeals_Postpaid" || type === "SpecialDeals_Prepaid" || type === "NojoomPartner" || type === "GTL" || type === "NojoomHotDeals" || type === "TransferPoints" || type === "OoredeoRewardsDetails" || type === "SpecialDealsPrePaid" ) return list?.amount;
    else if(type === "DigitalServices" || type === "NojoomEarnPoints" || type === "nojoomPartners" || type === "transferPoints" || type === "OoredeoRewards" || type === "ooredoRewardsList") return list?.price;
    else if(type === "addons" || type === "bundles" || type=== "roamingDeals" || type === "RoamingMultiContries" || type === "addonDetails" || type === "recentpurchase" || type === "addon" || type === "DigitalService" || type === "roaming" ) return list?.offerbaseprice;
    else if(type === "nojoomPartner" || type === "RoamingCountries") return list?.dofferbaseprice;
    else if(type === "Nojoom_Partner" ) return list?.title?.slice(0,4);
    else if(type === "OoredeooServices" ) return list?.points + "points"
}
const getCategory = (list, type) =>{

    if(type === "SpecialDeals_Postpaid" || type === "DigitalServices" || type === "SpecialDeals_Prepaid" || type === "nojoomPartners" || type === "nojoomPartner" || type === "transferPoints"  || type === "NojoomEarnPoints" || type === "NojoomPartner" || type === "GTL" || type === "NojoomHotDeals" || type === "addonDetails" || type === "OoredeoRewardsDetails" || type === "DigitalService") return list?.category;
    else if(type === "addons" || type === "bundles"  || type === "roamingDeals"  || type === "recentpurchase" || type === "roaming" ) return list?.offercategory;
    else if(type === "OoredeoRewards" || type === "ooredoRewardsList") return list?.type;
    else if(type === "RoamingCountries" || type === "RoamingMultiContries" ) return list?.eventlog_catg;
    else if(type === "SpecialDealsPrePaid" || type === "Nojoom_Partner" || type === "OoredeooServices" ) return type
    else if(type === "addon") return list?.paymenttype
}


const GTM_View_Item = (item, type) =>{
    window.dataLayer.push({ecommerce: null})
    window.dataLayer.push({
        event: "view_item",
        ecommerce: {
          currency: item?.currency ?? "",
          value: getPrice(item, type) ?? "",
          items: [{
            item_id: getId(item, type) ?? "",
            item_name: getItemName(item, type) ?? "",
            affiliation: "",
            coupon: "",
            currency: item?.currency ?? "",
            discount: item?.discount ?? "",
            index: item?.position ?? "",
            item_brand: "",
            item_category: getCategory(item, type) ?? "",
            item_category2: "",
            item_category3: "",
            item_category4: "",
            item_category5: "",
            item_list_id: "",
            item_list_name: type,
            item_variant: "",
            location_id: "",
            price: getPrice(item, type) ?? "",
            quantity: 1
          }]
        }
      })
}

const GTM_Select_Item = (item, type) =>{
    window.dataLayer.push({ecommerce: null})
    window.dataLayer.push({
        event: "select_item",
        ecommerce: {
          "currency": item?.currency ?? "KD",
          "value":  getPrice(item, type) ?? "",
          "items": [{
            "item_id": getId(item, type) ?? "" ,
            "item_name": getItemName(item, type) ?? "",
            "affiliation": "",
            "coupon": "",
            "currency": item?.currency ?? "KD",
            "discount": item?.discount ?? "",
            "index": item?.position ?? 0,
            "item_brand": "",
            "item_category": getCategory(item, type) ?? "",
            "item_category2": "",
            "item_category3": "",
            "item_category4": "",
            "item_category5": "",
            "item_list_id": "",
            "item_list_name": type,
            "item_variant": "",
            "location_id": "",
            "price":  getPrice(item, type) ?? "",
            "quantity": 1
          }]
        }
      }); 
}

const GTM_View_Items_List = (result, type) =>{
    window.dataLayer.push({ecommerce: null})
    const arrayList = []
    result?.map((item) =>
        arrayList.push({
        "item_id": getId(item, type),
        "item_name": getItemName(item, type),
        "affiliation": "",
        "coupon": "",
        "currency": item?.currency ?? "",
        "discount": item?.discount ?? "",
        "index": item?.position ?? "",
        "item_brand": "",
        "item_category": getCategory(item, type) ?? "",
        "item_category2": "",
        "item_category3": "",
        "item_category4": "",
        "item_category5": "",
        "item_list_id": "",
        "item_list_name": type,
        "item_variant": "",
        "location_id": "",
        "price": getPrice(item, type) ?? "",
        "quantity": 1
        }));
    window.dataLayer.push({
        event: 'view-item_list',
        ecommerce:{
            items: arrayList
        }
    }); 
}

const GTM_Logout = (pagename, msisdn, logintype, status) =>{
    window.dataLayer.push({
        event: 'e_logout',
        p_language: getItemOfSessionStorage(SELECTED_LANG),
        p_subsite:'CORPWEB',
        p_channel:'WEB',
        p_previouspagename: previousPage(pagename),
        p_customerid: getItemOfSessionStorage("Customerid") ?? "",
        p_customertype: getItemOfSessionStorage(AUTH_KEY) ? "existing" : "guest",        
        p_planid: JSON.parse(getItemOfSessionStorage("c_net"))?.planid ?? '',
        p_planname: JSON.parse(getItemOfSessionStorage("c_net"))?.planname ?? "",           
        p_logintype:getItemOfSessionStorage(AUTH_KEY) ? logintype : "Guest",        
        p_loginstatus: getItemOfSessionStorage(AUTH_KEY) ? "yes" : "no",        
        p_msisdn:msisdn,        
        p_pagename: pagename,
        p_status: status,        
        p_statusdesc:'Logout Successful.',
    });      
}

const GTM_Change_Msisdn = (pagename, msisdn, customerid, logintype, status) =>{
    window.dataLayer.push({
        event: 'e_changemsisdn',
        p_language: getItemOfSessionStorage(SELECTED_LANG),
        p_subsite:'CORPWEB',
        p_channel:'WEB',
        p_previouspagename: previousPage(pagename),
        p_customerid: customerid ?? "",
        p_customertype: getItemOfSessionStorage(AUTH_KEY) ? "existing" : "guest",     
        p_planid:  JSON.parse(getItemOfSessionStorage("c_net"))?.planid ?? '',
        p_planname: JSON.parse(getItemOfSessionStorage("c_net"))?.planname ?? "",      
        p_logintype:getItemOfSessionStorage(AUTH_KEY) ? logintype : "Guest",        
        p_loginstatus:getItemOfSessionStorage(AUTH_KEY) ? "yes" : "no",        
        p_msisdn: getItemOfSessionStorage('pre_id'),        
        p_pagename:pagename,
        p_status: status,        
        p_statusdesc: "Msisdn changed successfully",
        p_actionmsisdn: msisdn
    });      
}

const GTM_Pay =( pagename, msisdn, message, logintype, paymentType, status,payDetails,TotalPrice, msisdnlist, serviceType ) =>{
    window.dataLayer.push({
        event: 'e_pay',        
        p_language: getItemOfSessionStorage(SELECTED_LANG),
        p_subsite: "CORPWEB",
        p_channel: "WEB",
        p_previouspagename: previousPage(pagename),
        p_customerid: getItemOfSessionStorage("Customerid") ?? "",
        p_customertype: getItemOfSessionStorage(AUTH_KEY) ? "existing" : "guest",        
        p_planid: JSON.parse(getItemOfSessionStorage("c_net"))?.planid ?? '',
        p_planname: JSON.parse(getItemOfSessionStorage("c_net"))?.planname ?? "",   
        p_logintype: getItemOfSessionStorage(AUTH_KEY) ? logintype : "Guest",        
        p_loginstatus: getItemOfSessionStorage(AUTH_KEY) ? "yes" : "no",        
        p_msisdn: msisdn,        
        p_pagename: pagename,       
        p_status: status,        
        p_statusdesc: message ?? '',
        p_paymentservicetype: serviceType,        
        p_paymenttype: paymentType,        
        p_paymentdetails: payDetails,
        p_totalamount: TotalPrice,        
        p_mobilenumberlist: msisdnlist ? msisdnlist.split(',').map((item) => item) : ''
    });
}


const GTM_ChangeLanguage = (logintype) =>{
    let {pagename, msisdn} = JSON.parse(getItemOfSessionStorage("currentPage"))
    
    window.dataLayer.push({
        'event': 'e_changelang',
        'p_language': getItemOfSessionStorage(SELECTED_LANG),
        'p_subsite': "CORPWEB",
        'p_channel': "WEB",
        'p_previouspagename': previousPage(pagename),
        'p_customerid': getItemOfSessionStorage("Customerid") ?? "",
        'p_customertype': getItemOfSessionStorage(AUTH_KEY) ? "existing" : "guest",
        'p_planid': JSON.parse(getItemOfSessionStorage("c_net"))?.planid ?? '',
        'p_planname': JSON.parse(getItemOfSessionStorage("c_net"))?.planname ?? "",
        'p_logintype': getItemOfSessionStorage(AUTH_KEY) ? logintype : "Guest", 
        'p_loginstatus': getItemOfSessionStorage(AUTH_KEY) ? "yes" : "no", 
        'p_msisdn': msisdn,
        'p_pagename': pagename,
        'p_status':'Success',
        'p_statusdesc':'launguage changed successfully'
    });
}

const GTM_BalanceTransfer = (pagename, msisdn, logintype, status, statusDesc, amount, recipient) =>{
    window.dataLayer.push({
        'event': 'e_balancetransfer',
        'p_language':  getItemOfSessionStorage(SELECTED_LANG),
        'p_subsite': "CORPWEB",
        'p_channel': "WEB",
        'p_previouspagename': previousPage(pagename),
        'p_customerid': getItemOfSessionStorage("Customerid") ?? "",
        'p_customertype': getItemOfSessionStorage(AUTH_KEY) ? "existing" : "guest",        
        'p_planid': JSON.parse(getItemOfSessionStorage("c_net"))?.planid ?? '',
        'p_planname': JSON.parse(getItemOfSessionStorage("c_net"))?.planname ?? "",        
        'p_logintype': getItemOfSessionStorage(AUTH_KEY) ? logintype : "Guest",        
        'p_loginstatus': getItemOfSessionStorage(AUTH_KEY) ? "yes" : "no",        
        'p_msisdn': msisdn,        
        'p_pagename': pagename,
        'p_status': status,
        'p_statusdesc': statusDesc,              
        'p_totalamount': amount,            
        'p_recipient': recipient
    })
}

const GTM_Internet_Transfer = (pagename, msisdn, logintype, status, statusDesc, recipient, actionmsisdn, actionToggle, transferAction) =>{
    window.dataLayer.push({
        'event': 'e_internettransfer',
        'p_language': getItemOfSessionStorage(SELECTED_LANG),
        'p_subsite': "CORPWEB",
        'p_channel': "WEB",
        'p_previouspagename': previousPage(pagename),
        'p_customerid': getItemOfSessionStorage("Customerid") ?? "",
        'p_customertype': getItemOfSessionStorage(AUTH_KEY) ? "existing" : "guest",        
        'p_planid': JSON.parse(getItemOfSessionStorage("c_net"))?.planid ?? '',
        'p_planname':  JSON.parse(getItemOfSessionStorage("c_net"))?.planname ?? "",        
        'p_logintype': getItemOfSessionStorage(AUTH_KEY) ? logintype : "Guest",        
        'p_loginstatus': getItemOfSessionStorage(AUTH_KEY) ? "yes" : "no",        
        'p_msisdn': msisdn,        
        'p_pagename': pagename,
        'p_status': status,        
        'p_statusdesc': statusDesc,             
        'p_recipient': recipient,
        'p_actionmsisdn': actionmsisdn,
        'p_actiontoggle': actionToggle,
        'p_inetransferaction': transferAction
    });
}

const GTM_Set_primary = (pagename, msisdn, logintype, status, statusDesc, actionMsisdn, actionToggle) =>{
    window.dataLayer.push({
        'event': 'e_setprimary',
        'p_language': getItemOfSessionStorage(SELECTED_LANG),
        'p_subsite': "CORPWEB",
        'p_channel': "WEB",
        'p_previouspagename': previousPage(pagename),
        'p_customerid': getItemOfSessionStorage("Customerid") ?? "",
        'p_customertype': getItemOfSessionStorage(AUTH_KEY) ? "existing" : "guest",        
        'p_planid': JSON.parse(getItemOfSessionStorage("c_net"))?.planid ?? '',
        'p_planname': JSON.parse(getItemOfSessionStorage("c_net"))?.planname ?? "",        
        'p_logintype':  getItemOfSessionStorage(AUTH_KEY) ? logintype : "Guest",        
        'p_loginstatus': getItemOfSessionStorage(AUTH_KEY) ? "yes" : "no",        
        'p_msisdn': msisdn,        
        'p_pagename': pagename,
        'p_status': status,        
        'p_statusdesc': statusDesc,        
        'p_actionmsisdn': actionMsisdn,        
        'p_actiontoggle': actionToggle
    });
}

const GTM_NojoomRedeem = (pagename, msisdn, logintype, status, statusDesc, nojoomPoints, nojoomProductName, nojoomProductType) =>{
    window.dataLayer.push({
        'event': 'e_nojoomredeem',
        'p_language': getItemOfSessionStorage(SELECTED_LANG),
        'p_subsite': "CORPWEB",
        'p_channel': "WEB",
        'p_previouspagename': previousPage(pagename),
        'p_customerid': getItemOfSessionStorage("Customerid") ?? "",
        'p_customertype': getItemOfSessionStorage(AUTH_KEY) ? "existing" : "guest",        
        'p_planid': JSON.parse(getItemOfSessionStorage("c_net"))?.planid ?? '',
        'p_planname': JSON.parse(getItemOfSessionStorage("c_net"))?.planname ?? "",        
        'p_logintype': getItemOfSessionStorage(AUTH_KEY) ? logintype : "Guest",        
        'p_loginstatus': getItemOfSessionStorage(AUTH_KEY) ? "yes" : "no",        
        'p_msisdn': msisdn,        
        'p_pagename': pagename,
        'p_status': status,        
        'p_statusdesc': statusDesc,        
        'p_nojoompoints': nojoomPoints,        
        'p_nojoomproductname': nojoomProductName,
        'p_nojoomproducttype': nojoomProductType
    });
}

const GTM_NojoomManage = (pagename, msisdn, logintype, status, statusDesc, actionmsisdn) =>{
    window.dataLayer.push({
        'event': 'e_nojoommanage',     
        'p_language': getItemOfSessionStorage(SELECTED_LANG),
        'p_subsite': "CORPWEB",
        'p_channel': "WEB",
        'p_previouspagename': previousPage(pagename),
        'p_customerid': getItemOfSessionStorage("Customerid") ?? "",
        'p_customertype': getItemOfSessionStorage(AUTH_KEY) ? "existing" : "guest",        
        'p_planid':  JSON.parse(getItemOfSessionStorage("c_net"))?.planid ?? '',
        'p_planname': JSON.parse(getItemOfSessionStorage("c_net"))?.planname ?? "",        
        'p_logintype': getItemOfSessionStorage(AUTH_KEY) ? logintype : "Guest",        
        'p_loginstatus': getItemOfSessionStorage(AUTH_KEY) ? "yes" : "no",        
        'p_msisdn': msisdn,        
        'p_pagename': pagename,  
        'p_status': status,        
        'p_statusdesc': statusDesc,        
        'p_actionmsisdn': actionmsisdn
    });
}

const GTM_NojoomTransfer = (pagename, msisdn, logintype, status, statusDesc, recipient, nojoomProductName, nojoomProductType, nojoomTransferType) =>{ 
    window.dataLayer.push({
        'event': 'e_nojoomtransfer',
        'p_language': getItemOfSessionStorage(SELECTED_LANG),
        'p_subsite': "CORPWEB",
        'p_channel': "WEB",
        'p_previouspagename': previousPage(pagename),
        'p_customerid':  getItemOfSessionStorage("Customerid") ?? "",
        'p_customertype':getItemOfSessionStorage(AUTH_KEY) ? "existing" : "guest",        
        'p_planid': JSON.parse(getItemOfSessionStorage("c_net"))?.planid ?? '',
        'p_planname': JSON.parse(getItemOfSessionStorage("c_net"))?.planname ?? "",        
        'p_logintype': getItemOfSessionStorage(AUTH_KEY) ? logintype : "Guest",       
        'p_loginstatus': getItemOfSessionStorage(AUTH_KEY) ? "yes" : "no",         
        'p_msisdn': msisdn,        
        'p_pagename': pagename,
        'p_status': status,        
        'p_statusdesc': statusDesc,           
        'p_recipient': recipient,        
        'p_nojoomproductname': nojoomProductName,        
        'p_nojoomproducttype': nojoomProductType,        
        'p_nojoomtransfertype': nojoomTransferType
    });
}

const GTM_NojoomBuy = (pagename, msisdn, logintype, status, statusDesc, paymentType) =>{
    window.dataLayer.push({
        'event': 'e_nojoombuy', 
        'p_language': getItemOfSessionStorage(SELECTED_LANG),
        'p_subsite': "CORPWEB",
        'p_channel': "WEB",
        'p_previouspagename': previousPage(pagename),
        'p_customerid': getItemOfSessionStorage("Customerid") ?? "",
        'p_customertype': getItemOfSessionStorage(AUTH_KEY) ? "existing" : "guest",        
        'p_planid': JSON.parse(getItemOfSessionStorage("c_net"))?.planid ?? '',
        'p_planname':  JSON.parse(getItemOfSessionStorage("c_net"))?.planname ?? "",        
        'p_logintype':  getItemOfSessionStorage(AUTH_KEY) ? logintype : "Guest",        
        'p_loginstatus': getItemOfSessionStorage(AUTH_KEY) ? "yes" : "no",        
        'p_msisdn': msisdn,        
        'p_pagename': pagename,
        'p_status': status,        
        'p_statusdesc': statusDesc,         
        'p_paymenttype': paymentType
    })
}

const GTM_Begin_Checkout = (item, type) =>{
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
        "event": "begin_checkout",
        "coupon": "",
        "ecommerce": {
            "currency": item?.currency ?? "KD",
            "value": (item?.offerbaseprice || item?.amount || item?.price) ?? getPrice(item, type) ?? "",
            "items": [{
                "item_id":  getId(item, type) ?? "",
                "item_name":  item?.title ?? "",
                "affiliation": "",
                "coupon": "",
                "currency": item?.currency ?? "KD",
                "discount": item?.discount ?? "",
                "index":  item?.position ?? "",
                "item_brand": "",
                "item_category":  getCategory(item, type) ?? type,
                "item_category2": "",
                "item_category3": "",
                "item_category4": "",
                "item_category5": "",
                "item_list_id": "",
                "item_list_name": type,
                "item_variant": "",
                "price": (item?.offerbaseprice || item?.amount || item?.price) ?? getPrice(item, type) ?? "",
                "quantity": 1
            }]
        }
    })
}

const GTM_Add_Payment_Info = (item, type, paymenttype) =>{
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
        "event": "add_payment_info",
        "promotion_id": "",
        "promotion_name": "",
        "ecommerce": {
            "currency": item?.currency ?? "KD",
            "value": (item?.offerbaseprice || item?.amount || item?.price) ?? "",
            "payment_type": paymenttype,    
            "coupon": "",
            "items": [{
                "item_id":  getId(item, type) ?? "",
                "item_name":  item?.title ?? "",
                "affiliation": "",
                "coupon": "",
                "currency": item?.currency ?? "KD",
                "discount": item?.discount ?? "",
                "index":  item?.position ?? "",
                "item_brand": "",
                "item_category":  getCategory(item, type) ?? type,
                "item_category2": "",
                "item_category3": "",
                "item_category4": "",
                "item_category5": "",
                "item_list_id": "",
                "item_list_name": type,
                "item_variant": "",
                "price": (item?.offerbaseprice || item?.amount || item?.price) ?? "",
                "quantity": 1
            }]
        }
    })
}

const GTM_Purchase = (item, type, paymnetType = "", transid = "") =>{
    window.dataLayer.push({ ecommerce: null });
    // window.dataLayer.push({
    //     "event": "purchase",
    //     "promotion_id": "",
    //     "promotion_name": "",
    //     "ecommerce": {
    //         "currency": item?.currency ?? "KD",
    //         "value": (item?.offerbaseprice || item?.amount || item?.price) ?? getPrice(item) ?? "",
    //         "payment_type": paymnetType,    
    //         "coupon": "",
    //         "transaction_id": transid ?? "",
    //         "affiliation": "",
    //         "items": [{
    //             "item_id":  getId(item, type) ?? "",
    //             "item_name":  item?.title ?? getItemName(item, type) ??  "",
    //             "affiliation": "",
    //             "coupon": "",
    //             "currency": item?.currency ?? "KD",
    //             "discount": item?.discount ?? "",
    //             "index":  item?.position ?? "",
    //             "item_brand": "",
    //             "item_category":  getCategory(item, type) ?? type,
    //             "item_category2": "",
    //             "item_category3": "",
    //             "item_category4": "",
    //             "item_category5": "",
    //             "item_list_id": "",
    //             "item_list_name": type,
    //             "item_variant": "",
    //             "price": (item?.offerbaseprice || item?.amount || item?.price) ?? getPrice(item) ?? "",
    //             "quantity": 1
    //         }]
    //     }
    // })
}